import { Button } from '@platform/components';
import GoogleLogo from './google_logo.svg';

type GoogleSignInButtonProps = {
  isRep?: boolean;
  isToSConfirmed?: boolean;
  onClickIfToSNotConfirmed?: () => void;
  orgInviteId?: string | null;
  impactPartnerId?: string | null;
  corporateClientId?: string | null;
};

export const GoogleSignUpButton = (props: GoogleSignInButtonProps) => {
  const {
    isToSConfirmed,
    isRep,
    onClickIfToSNotConfirmed,
    orgInviteId,
    impactPartnerId,
    corporateClientId,
  } = { ...props };

  let logInHref = import.meta.env.VITE_API_HOST + '/login/google';

  logInHref += `?is_rep=${!!isRep}`;
  logInHref += impactPartnerId ? `&impact_partner_id=${impactPartnerId}` : '';
  logInHref += corporateClientId ? `&corporate_client_id=${corporateClientId}` : '';
  logInHref += orgInviteId ? `&org_invite_id=${orgInviteId}` : '';

  //Because OAuth sign in isn't a button but a link, we use a button temporarily
  //To handle the press if the ToS isn't confirmed then when it is confirmed we replace it with the link
  if (!isToSConfirmed) {
    return (
      <div>
        <Button
          onPress={onClickIfToSNotConfirmed}
          variant='secondary-gray'
          size='lg'
          additionalClassnames='w-full'
        >
          <img src={GoogleLogo} /> {'Create with Google'}
        </Button>
      </div>
    );
  }

  return (
    <div>
      <Button href={logInHref} variant='secondary-gray' size='lg' additionalClassnames='w-full'>
        <img src={GoogleLogo} /> {'Create with Google'}
      </Button>
    </div>
  );
};
